export default "__VITE_ASSET__upcuxK1U__"